import { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import './Faq.css';

const FAQS = [
  {
    q: 'How does MeruBot conduct AI interviews?',
    a: 'MeruBot uses advanced LLMs to generate role-specific questions, conducts voice-based interviews, and evaluates candidate responses in real time using custom scoring rubrics tailored to your job requirements.',
  },
  {
    q: 'Which industries and job roles does MeruBot support?',
    a: 'We support 50+ industries including IT, Healthcare, Finance, Sales, and Manufacturing covering 500+ job roles. Custom configurations are available for niche or senior roles.',
  },
  {
    q: 'How accurate is the AI evaluation?',
    a: 'Our evaluation engine achieves 95% accuracy benchmarked against human recruiters. It scores responses across multiple dimensions communication, technical depth, relevance, and confidence.',
  },
  {
    q: 'Is candidate data secure and private?',
    a: 'Yes, MeruBot maintains enterprise-grade security standards to ensure all candidate data remains private and protected. As an ISO-certified company, we adhere to rigorous international protocols for data encryption and secure information management.',
  },
  {
    q: "Is customer support available during onboarding?",
    a: "Yes, MeruBot provides dedicated support during onboarding to ensure your interview workflows are configured perfectly from day one. Our team is here to help you calibrate your agent and launch your first automated screening call with total confidence.",
  },
];

function AccordionItem({ item, index, isOpen, onToggle }) {
  const bodyRef = useRef(null);
  const innerRef = useRef(null);

  useEffect(() => {
    const body = bodyRef.current;
    const inner = innerRef.current;
    if (!body || !inner) return;

    body.style.height = isOpen ? `${inner.offsetHeight}px` : '0px';
  }, [isOpen]);

  return (
    <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
      <button className="faq-question" onClick={() => onToggle(index)} aria-expanded={isOpen}>
        <span className="faq-question__num">{String(index + 1).padStart(2, '0')}</span>
        <span className="faq-question__text">{item.q}</span>
        <span className="faq-question__icon">
          <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="6" y1="1" x2="6" y2="11" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="1" y1="6" x2="11" y2="6" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      <div className="faq-body" ref={bodyRef}>
        <div className="faq-body__inner" ref={innerRef}>
          <p className="faq-answer">{item.a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      }),
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      sectionRef.current.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
    }

    return () => observer.disconnect();
  }, []);

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="faq-section" ref={sectionRef}>
      <div className="faq-container">
        <div className="faq-orb faq-orb--1" />
        <div className="faq-orb faq-orb--2" />

        <div className="faq-header reveal">
          <div className="section-label">Help Center</div>
          <h2 className="faq-title">
            Got <span className="faq-title__gradient">Questions?</span>
            <br />
            We&apos;ve got answers.
          </h2>
          <p className="faq-subtitle">
            Everything you need to know about MeruBot and AI-driven hiring.
          </p>

          {false && (
            <div className="faq-accordion reveal">
              {FAQS.map((item, index) => (
                <AccordionItem
                  key={item.q}
                  item={item}
                  index={index}
                  isOpen={openIndex === index}
                  onToggle={handleToggle}
                />
              ))}
            </div>
          )}

            {/* CTA */}
           {/* CTA */}
<div className="faq-cta reveal">

  <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
    <Link to="/privacy-policy?tab=privacy&section=scope" className="faq-cta__link">
  Privacy Policy
</Link>

<span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
<Link to="/privacy-policy?tab=security&section=sec-overview" className="faq-cta__link">
  Security and Compilance
</Link>

  
  <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
    <Link to="/privacy-policy?tab=terms&section=tos-definitions" className="faq-cta__link">
  Terms of Services
</Link>

<span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
<Link to="/privacy-policy?tab=ai&section=ai-definitions" className="faq-cta__link">
  AI Features Terms and Conditions
</Link>
    
    


   <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
   <Link to="/privacy-policy?tab=faq" className="faq-cta__link">
  FAQs
</Link>
<span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
              <Link to="/contact-us" className="faq-cta__link">
                Contact Us
              </Link>
 
  
 
  </div>
</div>
          </div>
          <footer className="pp-footer">
          © {new Date().getFullYear()} CyberMeru Technologies Pvt. Ltd. · All Rights Reserved.
        </footer>
      </div>
    </section>
  );
}
